export default __webpack_public_path__ + "static/media/2213.607fedf9.png";